/* Este archivo crea una instancia personalizada para el manejo de datos usando el token */
import axios from 'axios';
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import EventBus from '../utils/event-bus';
import { Config } from '../config';

Vue.use(VueSweetalert2);

const instance = axios.create({
  baseURL: Config.backendUrl
});

instance.interceptors.response.use((response) => {
  EventBus.$emit('stop-loading');
  return response;
}, (error) => {
  EventBus.$emit('stop-loading');

  if (error.response.status === 401) {
    EventBus.$emit('tokeninvalid');
    Vue.swal({
      title: 'Tiempo de sesión agotado',
      text: 'La sessión ha expirado y necesitas hacer login de nuevo',
      type: 'warning',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        // this.$store.dispatch('logout')
        // this.$router.push({name: 'login'});
        EventBus.$emit('tokeninvalid');
        EventBus.$emit('logout');
        // window.location = '/login';
      }
    });
  } else {
    return Promise.reject(error);
  }
});

instance.interceptors.request.use(function (response) {
  // spinning start to show
  // UPDATE: Add this code to show global loading indicator
  EventBus.$emit('start-loading');
  return response;
}, function (error) {
  return Promise.reject(error);
});

instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.defaults.headers.get['Accepts'] = 'application/json';

export default instance;
